<h1 class="accent-background-element">Generate Codes</h1>

<mat-dialog-content>
    @if ((loaded | async) ===true) { <form [formGroup]="form">
        <div class="row">

            <div class="column">
                <h4>Amount*</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <input matInput placeholder="Amount of codes" type="number" formControlName="count"
                            class="accent-border-element mat-body">
                    </mat-form-field>
                </div>
            </div>
           
            <div class="column">
                <h4>Type*</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <mat-select formControlName="type" class='accent-border-element  mat-body' placeholder="Type">
                            @for (codeType of ReleaseCodeType | keyvalue; track codeType) {
                            <mat-option class='accent-hover-element' [value]='codeType.value'>{{codeType.key|titlecase
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

        </div>
        @if (isSubscription) {
        <div class="row">

            <div class="column">
                <h4>Subscription Duration*</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <mat-select formControlName="subscriptionDuration" class='accent-border-element  mat-body'
                            placeholder="Subscription Duration">
                            @for (subscriptionDuration of SubscriptionDurationType | keyvalue; track
                            subscriptionDuration) {
                            <mat-option class='accent-hover-element'
                                [value]='subscriptionDuration.value'>{{getSubscriptionDurationText(subscriptionDuration.value)
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            @if (withDuration) {
            <div class="column">
                <h4>Trial Duration*</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <input placeholder="Trial Duration" type="number" matInput formControlName="trialDuration"
                            class="accent-border-element mat-body">
                    </mat-form-field>
                </div>
            </div>}
        </div>}
        @if (isPrescription) {
        <div class="row">
            <div class="toggle">
                <h4>Sound Therapy:&nbsp;</h4>
                <div>
                    <mat-slide-toggle formControlName="soundTherapy"></mat-slide-toggle>
                </div>
            </div>

            <div class="toggle">
                <h4>iCBT:&nbsp;</h4>
                <div>
                    <mat-slide-toggle formControlName="cbt"></mat-slide-toggle>
                </div>
            </div>
        </div>}
        <div class="row">
            <div class="column">
                <h4>Country of creation*</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <mat-select formControlName="countryOfCreation" class='accent-border-element  mat-body'
                            placeholder="Country of creation">
                            @for (countryID of CountriesIDs | keyvalue; track countryID) {
                            <mat-option class='accent-hover-element'
                                [value]='countryID.value'>{{this.getFullCountryNameById(countryID.value)}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="column">
                <h4>Shop ID</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <input matInput placeholder="Shop ID" formControlName="shopId"
                            class="accent-border-element mat-body">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="column">
                <h4>HCP ID</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <input matInput placeholder="HCP ID" formControlName="hcpId"
                            class="accent-border-element mat-body">
                    </mat-form-field>
                </div>
            </div>

            <div class="column">
                <h4>ENT office ID</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <input matInput placeholder="ENT office ID" formControlName="entOfficeId"
                            class="accent-border-element mat-body">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="column">
                <h4>ENT ID</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <input matInput placeholder="ENT ID" formControlName="entId"
                            class="accent-border-element mat-body">
                    </mat-form-field>
                </div>
            </div>

            <div class="column">
                <h4>Creator Name</h4>
                <div>
                    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
                        <input matInput placeholder="Creator Name" formControlName="creatorName"
                            class="accent-border-element mat-body">
                    </mat-form-field>
                </div>
            </div>

        </div>
        <div class="row">


            <div class="column">
                <h4>Notes</h4>
                <div>

                    <textarea matInput placeholder="Notes" formControlName="notes"
                        class="accent-border-element mat-body ">
      </textarea>
                </div>
            </div>
             <div class="toggle no-width">
                <h4>QR Codes:&nbsp;</h4>
                <div>
                    <mat-slide-toggle formControlName="withQRcodes"></mat-slide-toggle>
                </div>
            </div>
        </div>

    </form>
    }
    @if ((loaded | async) ===false) {
    <div class="spinner-container">
        <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
    </div>
    }
</mat-dialog-content>

@if ((loaded | async) ===true) {
<mat-dialog-actions>
    <div class="spacer"></div>
    <button mat-raised-button color="accent" [disabled]="isDisabledButton()" (click)="onSubmit()">Generate</button>
</mat-dialog-actions>}